export { default, type HeadingProps } from './heading.partial';
export { default as HeadingContextProvider } from './heading-context';
